import { render, staticRenderFns } from "./MbContentFindPaginator.vue?vue&type=template&id=832c368a&"
import script from "./MbContentFindPaginator.vue?vue&type=script&lang=js&"
export * from "./MbContentFindPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports